import auth0 from 'auth0-js'
import history from './history'
import {
  CLIENT_ID,
  DOMAIN,
  REDIRECT_URI,
  RESPONSE_TYPE,
  SCOPE
} from '../config/constants'

class Authenticate {
  auth0 = new auth0.WebAuth({
    allowedConnections: ['Username-Password-Authentication', 'google-oauth2'],
    clientID: CLIENT_ID,
    domain: DOMAIN,
    redirectUri: REDIRECT_URI,
    responseType: RESPONSE_TYPE,
    scope: SCOPE,
    allowSignUp: false,
    // configurationBaseUrl: 'https://cdn.eu.auth0.com'
  })

  handleAuthentication (loginFulfilled) {
    const href = window.location.href
    const jwt = href.split('#')[1] || null
    const authResult = jwt
      ? JSON.parse(
        '{"' +
            decodeURI(jwt)
              .replace(/"/g, '\\"')
              .replace(/&/g, '","')
              .replace(/=/g, '":"') +
            '"}'
      )
      : null
    if (authResult && authResult.access_token && authResult.id_token) {
      this.setSession(authResult, loginFulfilled)
      history.replace(window.location.pathname)
    }
    // this.auth0.parseHash((err, authResult) => {
    //   if (authResult && authResult.accessToken && authResult.idToken) {
    //     console.log(authResult)
    //     console.log(authResult.idToken.length)
    //     this.setSession(authResult, loginFulfilled)
    //     history.replace('/')
    //   } else if (err) {
    //     history.replace('/')
    //     console.log(err)
    //   }
    // })
  }

  setSession (authResult, loginFulfilled) {
    // Set the time that the access token will expire at

    const {
      expires_in: expiresIn,
      access_token: accessToken,
      id_token: idToken
    } = authResult

    const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime())
    loginFulfilled(accessToken, idToken, expiresAt)
    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('id_token', idToken)
    localStorage.setItem('expires_at', expiresAt)
    // navigate to the home route
    history.replace(window.location.pathname)
  }

  login () {
    this.auth0.authorize()
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    // navigate to the home route
    // history.replace('/')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    // const idToken = localStorage.getItem('id_token')
    // const jwt = jwtDecode(idToken)
    // console.log(jwt)
    // console.log(format(expiresAt, 'YYYY-MM-ddTHH:mm:ss.SSSZ'))
    // console.log(new Date().getTime() < expiresAt)
    return new Date().getTime() < expiresAt
  }
}

export const authenticate = new Authenticate()

export default Authenticate



// WEBPACK FOOTER //
// ./src/api/Authenticate.js